module.exports = __webpack_public_path__ + "img/smarthelp2_footer.f4293b6c.png";